export enum BatchEvent {
  hasBooked = 'has_booked',
  hasSeenAllTheHomepage = 'has_seen_all_the_homepage',
  hasSeenBookingPage = 'has_seen_booking_page',
  hasSeenBookOfferForSurvey = 'has_seen_book_offer_for_survey',
  hasSeenCinemaOfferForSurvey = 'has_seen_cinema_for_survey',
  hasSeenConcertForSurvey = 'has_seen_concert_for_survey',
  hasSeenCulturalVisitForSurvey = 'has_seen_cultural_for_survey',
  hasSeenEnoughHomeContent = 'has_seen_enough_home_content',
  hasSeenOffer = 'has_seen_offer',
  hasSeenOfferForSurvey = 'has_seen_offer_for_survey',
  hasSeenVenueForSurvey = 'has_seen_venue_for_survey',
  hasValidatedAccount = 'has_validated_account',
  hasValidatedEligibleAccount = 'has_validated_eligible_account',
  hasValidatedSubscription = 'has_validated_subscription',
  screenViewAccountCreated = 'screen_view_account_created',
  screenViewComeBackLater = 'screen_view_come_back_later',
  screenViewExpiredOrLostId = 'screen_view_expired_or_lost_id',
  screenViewVerifyEligibility = 'screen_view_verify_eligiblity',
}
